const global = {
  borderRadius: {
    default: '4px',
  },
};

export default global;
export type ThemeGlobal = typeof global;
export type ThemeGlobalKeys = keyof typeof global;
